<div class="container">
    <div class="generic-container">
        <section class="toolbar">
            <div class="search">
                <input
                    class="search-input"
                    type="text"
                    [placeholder]="'user.placeholder.searchUser' | translate"
                    [(ngModel)]="searchQuery"
                    (keyup.enter)="onSearch()"
                />
                <mat-icon class="search-btn" (click)="onSearch()">search</mat-icon>
            </div>
            <button mat-flat-button class="save-btn" (click)="goToAddUser()" *ngIf="hasPermission">
                <mat-icon>add</mat-icon>
                {{ "user.button.addUserBtn" | translate }}
            </button>
        </section>

        <section class="admin-list">
            <app-data-grid
                [tableColumns]="columns"
                [actions]="actions"
                [config]="config"
                (pageChange)="onPageChange($event)"
                (toggleChange)="onToggleChange($event)"
            ></app-data-grid>
        </section>
    </div>
</div>
